export const NOTIFICATION_TYPES = {
  LIKE_COMMENT: 'like_comment',
  COMMENT_POST: 'comment_post',
  REPLY_COMMENT: 'reply_comment',
  LIKE_POST: 'like_post'
};

export const CHANNEl_IDS: { [key: string]: string } = {
  SUPPORT: '65e59bb99417e5002c102af3',
  BUGS: '65e5a91f9417e5002c102c65',
  FAQ: '65e59aa99417e5002c102abb',
  INTRODUCTIONS: '65e59f199417e5002c102b67',
  TUTORIALS: '65e59c949417e5002c102b21',
};

export const ARTICLE_DEFAULT_IMAGE =
  'https://d2y5h3osumboay.cloudfront.net/light-mode-cover-thumbnail-2x.png';

export const DEVICE_BREAKPOINT = {
  MOBILE: 600,
  TABLET: 600,
  DESKTOP: 1200,
};

export const NOTIFICATION_MAPPER: { [key: string]: string } = {
  new_activity: "New activity",
  comment_post: "Comments on my posts",
  reply_post: "Replies to my comments",
  reply_comment: "Reply Comment",
  like_post: "Likes on my posts",
  like_comment: "Likes on my comments",
  new_post: "New posts",
  all_spaces: "Apply to all spaces",
}

export const DEFAULT_HTTP_ERR_MESSAGE = "Please try again later!";
